

// import React, { useState } from "react";
// import { Container, Card, Form, Row, Col, Button, InputGroup, Alert } from "react-bootstrap";
// import axiosInstance from "../utils/axiosInstance";
// import {
//   showSuccessToast,
//   showErrorToast,
//   showCenterErrorToast,
// } from "./toast";
// // Expanded list featuring North American, European, APAC, and LATAM regions
// const COUNTRY_CODES = [
//   { code: "US", dial: "+1", label: "🇺🇸 +1" },
//   { code: "CA", dial: "+1", label: "🇨🇦 +1" },
//   { code: "MX", dial: "+52", label: "🇲🇽 +52" },
//   { code: "GB", dial: "+44", label: "🇬🇧 +44" },
//   { code: "IN", dial: "+91", label: "🇮🇳 +91" },
//   { code: "AU", dial: "+61", label: "🇦🇺 +61" },
//   { code: "NZ", dial: "+64", label: "🇳🇿 +64" },
//   { code: "DE", dial: "+49", label: "🇩🇪 +49" },
//   { code: "FR", dial: "+33", label: "🇫🇷 +33" },
//   { code: "IT", dial: "+39", label: "🇮🇹 +39" },
//   { code: "ES", dial: "+34", label: "🇪🇸 +34" },
//   { code: "NL", dial: "+31", label: "🇳🇱 +31" },
//   { code: "BR", dial: "+55", label: "🇧🇷 +55" },
//   { code: "SG", dial: "+65", label: "🇸🇬 +65" },
//   { code: "AE", dial: "+971", label: "🇦🇪 +971" },
//   { code: "JP", dial: "+81", label: "🇯🇵 +81" },
//   { code: "KR", dial: "+82", label: "🇰🇷 +82" },
// ];

// // Fallback logic defaults explicitly to US (+1)
// const getDefaultDialCode = () => {
//   try {
//     const locale = navigator.language || navigator.languages?.[0] || "";
//     const region = locale.split("-")[1]?.toUpperCase();
//     const match = COUNTRY_CODES.find((c) => c.code === region);
//     return match ? match.dial : "+1";
//   } catch {
//     return "+1";
//   }
// };

// const emptyForm = () => ({
//   firstName: "",
//   lastName: "",
//   countryCode: getDefaultDialCode(),
//   phoneNumber: "",
//   email: "",
//   city: "",
//   state: "",
//   remarks: "",
// });

// const LeadPage = ({ onSuccess, onCancel, source = "lead" }) => {
//   const [formData, setFormData] = useState(emptyForm());
//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [submittedSuccess, setSubmittedSuccess] = useState(false);

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
//     if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
//     if (!formData.phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
//     else if (!/^\d{4,14}$/.test(formData.phoneNumber))
//       newErrors.phoneNumber = "Enter a valid phone number (digits only)";

//     // Email validation marked mandatory
//     if (!formData.email.trim()) {
//       newErrors.email = "Email address is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Enter a valid email address";
//     }

//     return newErrors;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phoneNumber") {
//       setFormData({ ...formData, phoneNumber: value.replace(/[^0-9]/g, "") });
//       if (errors.phoneNumber) setErrors({ ...errors, phoneNumber: null });
//       return;
//     }
//     setFormData({ ...formData, [name]: value });
//     if (errors[name]) setErrors({ ...errors, [name]: null });
//   };

//   const isFormComplete = () =>
//     formData.firstName.trim() &&
//     formData.lastName.trim() &&
//     formData.phoneNumber.trim() &&
//     formData.email.trim();

//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();

//     const validationErrors = validate();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = {
//         firstName: formData.firstName,
//         lastName: formData.lastName,
//         phoneNumber: `${formData.countryCode}${formData.phoneNumber}`,
//         email: formData.email,
//         city: formData.city || undefined,
//         state: formData.state || undefined,
//         remarks: formData.remarks || undefined,
//         source: source,
//       };

//       const response = await axiosInstance.post("/api/leads/addLead", payload);
//       if (response.status !== 200) throw new Error("Failed to save lead");
// showSuccessToast("Thank you! Your information has been saved successfully.");
//     //   setSubmittedSuccess(true);
//       setFormData(emptyForm());
//       if (onSuccess) onSuccess(response.data);
//     } catch (err) {
//       console.error(err);
//       setErrors({ submit: "Something went wrong. Please check your network and try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Container className="py-3" style={{ maxWidth: "620px", marginTop: "60px" }}>
//       <Card style={styles.card}>
//         {/* Brand Header Banner */}
//         <div style={styles.headerContainer}>
//           <h4 style={styles.headerTitle}>Visitor Registration</h4>
//         </div>

//         <Card.Body style={styles.body}>
//           {submittedSuccess && (
//             <Alert variant="success" className="py-2 px-3 mb-2" onClose={() => setSubmittedSuccess(false)} dismissible>
//               Thank you! Your information has been registered successfully.
//             </Alert>
//           )}

//           <Form onSubmit={handleSubmit}>
//             {/* FIRST & LAST NAME */}
//             <Row style={styles.rowGap}>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label style={styles.label}>
//                     First Name <span style={styles.required}>*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="firstName"
//                     placeholder="Enter first name"
//                     value={formData.firstName}
//                     onChange={handleChange}
//                     isInvalid={!!errors.firstName}
//                     style={styles.input}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.firstName}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label style={styles.label}>
//                     Last Name <span style={styles.required}>*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="lastName"
//                     placeholder="Enter last name"
//                     value={formData.lastName}
//                     onChange={handleChange}
//                     isInvalid={!!errors.lastName}
//                     style={styles.input}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.lastName}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             {/* PHONE NUMBER WITH COUNTRY SELECT */}
//             <Form.Group style={styles.fieldSpacing}>
//               <Form.Label style={styles.label}>
//                 Phone Number <span style={styles.required}>*</span>
//               </Form.Label>
//               <InputGroup>
//                 <Form.Select
//                   name="countryCode"
//                   value={formData.countryCode}
//                   onChange={handleChange}
//                   style={styles.countrySelect}
//                 >
//                   {COUNTRY_CODES.map((c) => (
//                     <option key={`${c.code}-${c.dial}`} value={c.dial}>
//                       {c.label}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <Form.Control
//                   type="tel"
//                   name="phoneNumber"
//                   placeholder="Enter phone number"
//                   value={formData.phoneNumber}
//                   onChange={handleChange}
//                   isInvalid={!!errors.phoneNumber}
//                   style={styles.phoneInput}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.phoneNumber}
//                 </Form.Control.Feedback>
//               </InputGroup>
//             </Form.Group>

//             {/* EMAIL ADDRESS (MANDATORY) */}
//             <Form.Group style={styles.fieldSpacing}>
//               <Form.Label style={styles.label}>
//                 Email Address <span style={styles.required}>*</span>
//               </Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 placeholder="Enter email address"
//                 value={formData.email}
//                 onChange={handleChange}
//                 isInvalid={!!errors.email}
//                 style={styles.input}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {errors.email}
//               </Form.Control.Feedback>
//             </Form.Group>

//             {/* CITY & STATE */}
//             <Row style={styles.rowGap}>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label style={styles.label}>City</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="city"
//                     placeholder="Enter city"
//                     value={formData.city}
//                     onChange={handleChange}
//                     style={styles.input}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label style={styles.label}>State</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="state"
//                     placeholder="Enter state"
//                     value={formData.state}
//                     onChange={handleChange}
//                     style={styles.input}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             {/* REMARKS */}
//             <Form.Group style={styles.fieldSpacing}>
//               <Form.Label style={styles.label}>Remarks / Requirements</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 name="remarks"
//                 placeholder="Any additional information..."
//                 value={formData.remarks}
//                 onChange={handleChange}
//                 style={styles.textarea}
//               />
//             </Form.Group>

//             {/* SUBMISSION ERROR ALERT */}
//             {errors.submit && (
//               <Alert variant="danger" style={styles.alertError}>
//                 {errors.submit}
//               </Alert>
//             )}

//             {/* ACTION BUTTONS */}
//             <div style={styles.actionContainer}>
//               {onCancel && (
//                 <Button
//                   type="button"
//                   variant="light"
//                   onClick={onCancel}
//                   style={styles.cancelBtn}
//                 >
//                   Cancel
//                 </Button>
//               )}
//               <Button
//                 type="submit"
//                 disabled={!isFormComplete() || submitting}
//                 style={styles.primaryBtn}
//               >
//                 {submitting ? "Submitting..." : "Submit"}
//               </Button>
//             </div>
//           </Form>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// // Styles configuration
// const BLUE = {
//   primary: "#2563eb",
//   border: "#cbd5e1",
//   textDark: "#0f172a",
//   textMuted: "#64748b",
//   bgGradient: "linear-gradient(135deg, #1e40af 0%, #2563eb 60%, #3b82f6 100%)",
// };

// const styles = {
//   card: {
//     border: "none",
//     borderRadius: "12px",
//     boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
//     overflow: "hidden",
//     backgroundColor: "#ffffff",
//   },
//   headerContainer: {
//     background: BLUE.bgGradient,
//     padding: "16px 20px 14px",
//     color: "#ffffff",
//   },
//   badge: {
//     display: "inline-block",
//     backgroundColor: "rgba(255, 255, 255, 0.2)",
//     color: "#ffffff",
//     fontSize: "10px",
//     fontWeight: "800",
//     letterSpacing: "0.8px",
//     padding: "2px 8px",
//     borderRadius: "8px",
//     marginBottom: "4px",
//     textTransform: "uppercase",
//   },
//   headerTitle: {
//     margin: 0,
//     fontSize: "18px",
//     fontWeight: 700,
//     color: "#ffffff",
//     lineHeight: "1.2",
//   },
//   headerSubtitle: {
//     margin: "2px 0 0",
//     fontSize: "12px",
//     color: "rgba(255, 255, 255, 0.85)",
//   },
//   body: {
//     padding: "20px",
//     backgroundColor: "#ffffff",
//   },
//   rowGap: {
//     marginBottom: "10px",
//   },
//   fieldSpacing: {
//     marginBottom: "10px",
//   },
//   label: {
//     fontSize: "11px",
//     fontWeight: "700",
//     color: BLUE.textDark,
//     marginBottom: "3px",
//     letterSpacing: "0.3px",
//     textTransform: "uppercase",
//   },
//   required: {
//     color: "#ef4444",
//     fontWeight: "800",
//   },
//   input: {
//     borderRadius: "6px",
//     border: `1px solid ${BLUE.border}`,
//     padding: "6px 10px",
//     fontSize: "13px",
//     color: BLUE.textDark,
//     backgroundColor: "#f8fafc",
//   },
//   countrySelect: {
//     borderRadius: "6px 0 0 6px",
//     border: `1px solid ${BLUE.border}`,
//     borderRight: "none",
//     padding: "6px 6px",
//     fontSize: "12px",
//     backgroundColor: "#eff6ff",
//     color: BLUE.textDark,
//     maxWidth: "100px",
//     flex: "0 0 100px",
//   },
//   phoneInput: {
//     borderRadius: "0 6px 6px 0",
//     border: `1px solid ${BLUE.border}`,
//     padding: "6px 10px",
//     fontSize: "13px",
//     color: BLUE.textDark,
//     backgroundColor: "#f8fafc",
//   },
//   textarea: {
//     borderRadius: "6px",
//     border: `1px solid ${BLUE.border}`,
//     padding: "6px 10px",
//     fontSize: "13px",
//     color: BLUE.textDark,
//     backgroundColor: "#f8fafc",
//     resize: "none",
//   },
//   alertError: {
//     marginTop: "10px",
//     marginBottom: "0",
//     borderRadius: "6px",
//     fontSize: "12px",
//     fontWeight: "600",
//     padding: "6px 10px",
//   },
//   actionContainer: {
//     display: "flex",
//     justifyContent: "flex-end",
//     gap: "10px",
//     marginTop: "16px",
//     paddingTop: "12px",
//     borderTop: "1px solid #f1f5f9",
//   },
//   cancelBtn: {
//     borderRadius: "6px",
//     padding: "6px 16px",
//     fontWeight: "600",
//     border: `1px solid ${BLUE.border}`,
//     color: BLUE.textMuted,
//     background: "#ffffff",
//     fontSize: "13px",
//   },
//   primaryBtn: {
//     borderRadius: "6px",
//     padding: "6px 20px",
//     fontWeight: "700",
//     background: BLUE.primary,
//     border: "none",
//     color: "#ffffff",
//     fontSize: "13px",
//   },
// };

// export default LeadPage;

import React, { useState } from "react";
import { Container, Card, Form, Row, Col, Button, Alert } from "react-bootstrap";
import PhoneInput, { getCountryCallingCode, isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axiosInstance from "../utils/axiosInstance";
import flags from "react-phone-number-input/flags";
import {
  showSuccessToast,
  showErrorToast,
  showCenterErrorToast,
} from "./toast";
import Select from "react-select";

// Guess the visitor's country from the browser locale (e.g. "en-US" -> "US"),
// falling back to "US". react-phone-number-input accepts any ISO 3166-1 code
// and covers every country itself, so we no longer maintain our own list.
const getDefaultCountry = () => {
  try {
    const locale = navigator.language || navigator.languages?.[0] || "";
    const region = locale.split("-")[1]?.toUpperCase();
    return region || "US";
  } catch {
    return "US";
  }
};

const emptyForm = () => ({
  firstName: "",
  lastName: "",
  phoneNumber: "", // stored in E.164 format, e.g. "+14155551234"
  email: "",
  city: "",
  state: "",
  remarks: "",
});

// Small flag renderer using the SVG flags react-phone-number-input already ships with.
const FlagIcon = ({ country, label }) => {
  const Flag = flags[country];
  return Flag ? (
    <Flag title={label} style={{ width: 20, height: 14, marginRight: 8, flexShrink: 0 }} />
  ) : (
    <span style={{ width: 20, marginRight: 8 }} />
  );
};

// Custom country selector for PhoneInput — swaps the default plain <select>
// for a searchable react-select dropdown, filterable by country name.
// Collapsed control shows flag + calling code only; the open dropdown list
// shows flag + country name + calling code.
const CountrySelectSearch = ({ value, onChange, options, disabled }) => {
  const selectOptions = options
    .filter((o) => o.value) // drop the blank "International" option
    .map((o) => ({
      value: o.value,
      label: o.label,
      callingCode: (() => {
        try {
          return getCountryCallingCode(o.value);
        } catch {
          return "";
        }
      })(),
    }));

  const selected = selectOptions.find((o) => o.value === value) || null;

  return (
    <Select
      options={selectOptions}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : undefined)}
      isDisabled={disabled}
      isSearchable
      placeholder="Search"
      formatOptionLabel={(opt, { context }) => (
        <div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%" }}>
          <FlagIcon country={opt.value} label={opt.label} />
          {context === "menu" && (
            <span
              style={{
                marginRight: 6,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
            >
              {opt.label}
            </span>
          )}
          <span
            style={{
              color: context === "menu" ? "#94a3b8" : "#0f172a",
              flexShrink: 0,
            }}
          >
            +{opt.callingCode}
          </span>
        </div>
      )}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      styles={countrySelectStyles}
    />
  );
};

const LeadPage = ({ onSuccess, onCancel, source = "IT Basic Training" }) => {
  const [formData, setFormData] = useState(emptyForm());
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submittedSuccess, setSubmittedSuccess] = useState(false);
  const [defaultCountry] = useState(getDefaultCountry());

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.phoneNumber) newErrors.phoneNumber = "Phone number is required";
    

    if (!formData.email.trim()) {
      newErrors.email = "Email address is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: null });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phoneNumber: value || "" });
    if (errors.phoneNumber) setErrors({ ...errors, phoneNumber: null });
  };

  const isFormComplete = () =>
    formData.firstName.trim() &&
    formData.lastName.trim() &&
    formData.phoneNumber &&
    formData.email.trim();

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber, // already E.164, e.g. +14155551234
        email: formData.email,
        city: formData.city || undefined,
        state: formData.state || undefined,
        remarks: formData.remarks || undefined,
        source: source,
      };

      const response = await axiosInstance.post("/api/leads/addLead", payload);
      if (response.status !== 200) throw new Error("Failed to save lead");
      showSuccessToast("Thank you! Your information has been saved successfully.");
      setFormData(emptyForm());
      if (onSuccess) onSuccess(response.data);
    } catch (err) {
      console.error(err);
      setErrors({ submit: "Something went wrong. Please check your network and try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="py-3" style={{ maxWidth: "620px", marginTop: "60px" }}>
      {/* Scoped overrides so react-phone-number-input matches the card's field styling */}
      <style>{`
        .lead-phone-input {
          display: flex;
          align-items: stretch;
          border: 1px solid ${BLUE.border};
          border-radius: 6px;
          background-color: #f8fafc;
          overflow: hidden;
        }
        .lead-phone-input.invalid {
          border-color: #ef4444;
        }
        .lead-phone-input .PhoneInputCountry {
          padding: 0 4px;
          background-color: #eff6ff;
          border-right: 1px solid ${BLUE.border};
          margin-right: 0;
          width: 80px;
          min-width: 80px;
          max-width: 80px;
          flex-shrink: 0;
          flex-grow: 0;
          display: flex;
          align-items: center;
          overflow: hidden;
        }
        .lead-phone-input .PhoneInputCountry > div {
          width: 100%;
          min-width: 0;
        }
        .lead-phone-input .PhoneInputInput {
          border: none;
          background: transparent;
          padding: 6px 10px;
          font-size: 13px;
          color: ${BLUE.textDark};
          outline: none;
          flex: 1 1 auto;
          width: 100%;
          min-width: 0;
        }
      `}</style>

      <Card style={styles.card}>
        <div style={styles.headerContainer}>
          <h4 style={styles.headerTitle}>Visitor Registration</h4>
        </div>

        <Card.Body style={styles.body}>
          {submittedSuccess && (
            <Alert variant="success" className="py-2 px-3 mb-2" onClose={() => setSubmittedSuccess(false)} dismissible>
              Thank you! Your information has been registered successfully.
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            {/* FIRST & LAST NAME */}
            <Row style={styles.rowGap}>
              <Col md={6}>
                <Form.Group>
                  <Form.Label style={styles.label}>
                    First Name <span style={styles.required}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    placeholder="Enter first name"
                    value={formData.firstName}
                    onChange={handleChange}
                    isInvalid={!!errors.firstName}
                    style={styles.input}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label style={styles.label}>
                    Last Name <span style={styles.required}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    placeholder="Enter last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    isInvalid={!!errors.lastName}
                    style={styles.input}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            {/* PHONE NUMBER - all countries via react-phone-number-input */}
            <Form.Group style={styles.fieldSpacing}>
              <Form.Label style={styles.label}>
                Phone Number <span style={styles.required}>*</span>
              </Form.Label>
              <div className={`lead-phone-input${errors.phoneNumber ? " invalid" : ""}`}>
                <PhoneInput
                  defaultCountry={defaultCountry}
                  countrySelectComponent={CountrySelectSearch}
                  value={formData.phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="Enter phone number"
                  
                />
              </div>
              {errors.phoneNumber && (
                <div style={styles.fieldError}>{errors.phoneNumber}</div>
              )}
            </Form.Group>

            {/* EMAIL ADDRESS (MANDATORY) */}
            <Form.Group style={styles.fieldSpacing}>
              <Form.Label style={styles.label}>
                Email Address <span style={styles.required}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email address"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                style={styles.input}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            {/* CITY & STATE */}
            <Row style={styles.rowGap}>
              <Col md={6}>
                <Form.Group>
                  <Form.Label style={styles.label}>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    placeholder="Enter city"
                    value={formData.city}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label style={styles.label}>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    placeholder="Enter state"
                    value={formData.state}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* REMARKS */}
            <Form.Group style={styles.fieldSpacing}>
              <Form.Label style={styles.label}>Remarks (Your Skills, Questions, Requirements)</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="remarks"
                placeholder="Any additional information..."
                value={formData.remarks}
                onChange={handleChange}
                style={styles.textarea}
              />
            </Form.Group>

            {/* SUBMISSION ERROR ALERT */}
            {errors.submit && (
              <Alert variant="danger" style={styles.alertError}>
                {errors.submit}
              </Alert>
            )}

            {/* ACTION BUTTONS */}
            <div style={styles.actionContainer}>
              {onCancel && (
                <Button
                  type="button"
                  variant="light"
                  onClick={onCancel}
                  style={styles.cancelBtn}
                >
                  Cancel
                </Button>
              )}
              <Button
                type="submit"
                disabled={!isFormComplete() || submitting}
                style={styles.primaryBtn}
              >
                {submitting ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

// react-select style overrides so the searchable country dropdown blends
// into the existing phone field instead of showing react-select's defaults.
const countrySelectStyles = {
  container: (base) => ({ ...base, width: "60%", minWidth: 0 }),
  control: (base) => ({
    ...base,
    minHeight: "30px",
    minWidth: 0,
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    flexWrap: "nowrap",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 2px",
    flexWrap: "nowrap",
    overflow: "hidden",
    minWidth: 0,
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0, minWidth: 0 }),
  indicatorsContainer: (base) => ({ ...base, padding: "0 2px" }),
  indicatorSeparator: () => ({ display: "none" }),
  singleValue: (base) => ({
    ...base,
    color: "#0f172a",
    fontSize: "13px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
  }),
  placeholder: (base) => ({ ...base, fontSize: "13px", whiteSpace: "nowrap" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  // Narrower dropdown list of country names, with a scroll cap so it doesn't
  // grow tall with every country listed.
  menu: (base) => ({ ...base, width: 210, fontSize: "12.5px" }),
  menuList: (base) => ({ ...base, maxHeight: 220, padding: "4px 0" }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    padding: "6px 8px",
    backgroundColor: state.isFocused ? "#eff6ff" : "#ffffff",
    color: "#0f172a",
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};

// Styles configuration
const BLUE = {
  primary: "#2563eb",
  border: "#cbd5e1",
  textDark: "#0f172a",
  textMuted: "#64748b",
  bgGradient: "linear-gradient(135deg, #1e40af 0%, #2563eb 60%, #3b82f6 100%)",
};

const styles = {
  card: {
    border: "none",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    backgroundColor: "#ffffff",
  },
  headerContainer: {
    background: BLUE.bgGradient,
    padding: "16px 20px 14px",
    color: "#ffffff",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: "#ffffff",
    fontSize: "10px",
    fontWeight: "800",
    letterSpacing: "0.8px",
    padding: "2px 8px",
    borderRadius: "8px",
    marginBottom: "4px",
    textTransform: "uppercase",
  },
  headerTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "#ffffff",
    lineHeight: "1.2",
  },
  headerSubtitle: {
    margin: "2px 0 0",
    fontSize: "12px",
    color: "rgba(255, 255, 255, 0.85)",
  },
  body: {
    padding: "20px",
    backgroundColor: "#ffffff",
  },
  rowGap: {
    marginBottom: "10px",
  },
  fieldSpacing: {
    marginBottom: "10px",
  },
  label: {
    fontSize: "11px",
    fontWeight: "700",
    color: BLUE.textDark,
    marginBottom: "3px",
    letterSpacing: "0.3px",
    textTransform: "uppercase",
  },
  required: {
    color: "#ef4444",
    fontWeight: "800",
  },
  input: {
    borderRadius: "6px",
    border: `1px solid ${BLUE.border}`,
    padding: "6px 10px",
    fontSize: "13px",
    color: BLUE.textDark,
    backgroundColor: "#f8fafc",
  },
  textarea: {
    borderRadius: "6px",
    border: `1px solid ${BLUE.border}`,
    padding: "6px 10px",
    fontSize: "13px",
    color: BLUE.textDark,
    backgroundColor: "#f8fafc",
    resize: "none",
  },
  fieldError: {
    color: "#ef4444",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "4px",
  },
  alertError: {
    marginTop: "10px",
    marginBottom: "0",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "600",
    padding: "6px 10px",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "16px",
    paddingTop: "12px",
    borderTop: "1px solid #f1f5f9",
  },
  cancelBtn: {
    borderRadius: "6px",
    padding: "6px 16px",
    fontWeight: "600",
    border: `1px solid ${BLUE.border}`,
    color: BLUE.textMuted,
    background: "#ffffff",
    fontSize: "13px",
  },
  primaryBtn: {
    borderRadius: "6px",
    padding: "6px 20px",
    fontWeight: "700",
    background: BLUE.primary,
    border: "none",
    color: "#ffffff",
    fontSize: "13px",
  },
};

export default LeadPage;